export enum MapSuCoActionType {
  INFO_QUERY_SUCCESS = 'INFO_QUERY_SUCCESS',
  INFO_QUERY_EMPTY = 'INFO_QUERY_EMPTY',
  SEARCH_FORM = 'SEARCH_FORM',
  NEW_ID_SUCO = 'NEW_ID_SUCO',
  SUBMIT_CHUYEN_DON_VI = 'SUBMIT_CHUYEN_DON_VI',
  INITIAL_ITEMS = 'INITIAL_ITEMS',
  ADD_ITEM = 'ADD_ITEM',
  REMOVE_ITEM = 'REMOVE_ITEM',
  SET_LAYER = 'SET_LAYER',
  SET_CHI_TIET = 'SET_CHI_TIET',
};
